import { useCallback } from 'react';
import DocumentItem from '@Features/MaterialRequest/requests/MaterialRequisition/form/components/DocumentsSection/components/DocumentListItems/components/DocumentItem';
import { useAppDispatch, useAppSelector } from '@Hooks/index';
import { getDocumentTypesDict } from '@Store/selectors/dictionarySelector';
import { modalActions } from '@Store/slices/modalSlice';
import { MaterialRequisitionDocumentResponse } from '@Types/api/form';
import { getFileTypeExt } from '@Features/utils/document';

interface DocumentTabItemMobileProps {
  dataSource: MaterialRequisitionDocumentResponse[];
}

const DocumentTabItemMobile: React.FC<DocumentTabItemMobileProps> = ({
  dataSource,
}) => {
  const dispatch = useAppDispatch();
  const documentTypes = useAppSelector(getDocumentTypesDict);

  const handleDeleteItem = useCallback(
    (documentItemId: MaterialRequisitionDocumentResponse) => {
      dispatch(
        modalActions.setStatusModal({
          key: JSON.stringify(documentItemId),
          status: true,
          type: 'Delete',
        })
      );
    },
    [dispatch]
  );

  const handleEditItem = (documentItemId: string): void => {
    dispatch(
      modalActions.setStatusModal({
        key: documentItemId,
        status: true,
        type: 'Edit',
      })
    );
  };

  if (!dataSource?.length) {
    return null;
  }

  return (
    <>
      {dataSource.map((document) => (
        <DocumentItem
          key={`${document.docName}-${document.id}`}
          deleteFlag={Boolean(document.deleteFlag)}
          docDesc={document.docDesc}
          docName={document.docName}
          isConfidential={Boolean(document.isConfidential)}
          procDocTypeOption={
            documentTypes.find(
              (documentType) => documentType.codeNum === document.procDocTypeId
            )?.codeDesc || 'N/A'
          }
          type={getFileTypeExt(document.filePath)}
          handleDeleteItem={() => handleDeleteItem(document)}
          handleEditItem={() => handleEditItem(document.filePath)}
        />
      ))}
    </>
  );
};

export default DocumentTabItemMobile;
